import React from "react";

import { observer } from "mobx-react";
import { Bet } from "@models";
import { useTranslation } from "react-i18next";

export const NumberOfEvents = observer(function NumberOfEvents(props: {
	bet: Bet;
}) {
	const { t } = useTranslation("mybets");
	const { bet } = props;

	return (
		<div className="bet__details__row">
			<div className="bet__details__col">
				{t("ITEM.ADDITIONAL_NUM_SELECTED_EVENTS")}
			</div>
			<div className="bet__details__col">{bet.eventCount}</div>
		</div>
	);
});
